import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { RegistrationQuestionAnswerModel } from '../models/questions/registration-questions-answer-model';
import { UserQuestionsStore, UserQuestionsState } from './user-questions.store';

@Injectable({ providedIn: 'root' })
export class UserQuestionsQuery extends QueryEntity<UserQuestionsState> {
  constructor(protected store: UserQuestionsStore) {
    super(store);
  }

  selectUserQuestion(): Observable<RegistrationQuestionAnswerModel[]> {
    return this.selectAll();
  }
}
